import axios from 'axios';

const KEY = 'AIzaSyB54zwSs4S-loGXpK9p3Qdu-bJyZcjup-o';

export default axios.create({
  baseURL: 'https://www.googleapis.com/youtube/v3',
  params: {
    part: 'snippet',
    maxResults: 5,
    key: KEY,
  },
});
